import { CancelledProductsNotification } from '@app/components/orders/CancelledProductsNotification';
import { ExpiredDelwinNotification } from '@app/components/orders/ExpiredDelwinNotification';
import { MissingCountryStateAlert, UnpaidInvoicesAlert } from '@app/components/various/GeneralAlertMessages';
import { Notification } from '@app/components/various/Notification';
import { getIsPrepaymentRequired, getPaymentTerm } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  orderDetails: Order.Single;
}
export const CheckoutAlerts = ({ orderDetails }: Props) => {
  const { t } = useTranslation(['checkout', 'payments']);
  const isPaymentRequired = useSelector(getIsPrepaymentRequired);
  const paymentTerm = useSelector(getPaymentTerm);
  const cancelledProducts = React.useMemo(
    () => orderDetails.order.products.filter(product => product.isCancelled),
    [orderDetails.order.products],
  );
  const hasCancelledProducts = !isEmpty(cancelledProducts);
  const hasMultipleOrders = (orderDetails.splitOrders ?? []).length > 1;
  const prepaymentPercent = paymentTerm?.prepaymentPercent;
  const paymentMessage = isPaymentRequired && isDefined(prepaymentPercent) ? t('payments:required_payment', { prepaymentPercent }) : null;

  return (
    <div className="flex flex-col gap-4">
      <MissingCountryStateAlert />
      <UnpaidInvoicesAlert />
      {hasCancelledProducts && <CancelledProductsNotification orderProducts={cancelledProducts} />}
      <ExpiredDelwinNotification order={orderDetails.order} />
      {isDefined(paymentMessage) && <Notification message={paymentMessage} type="info" />}
      {hasMultipleOrders && <Notification type="info" message={t('checkout:order_split_hint')} />}
    </div>
  );
};
